import React, { Component } from 'react';
import Carousel, { consts } from 'react-elastic-carousel';
import arrow from '../../assets/images/icons/arrow-left.svg';
import i18next from 'i18next';
import windowSize from 'react-window-size';

const breakPoints = [
    { width: 1, itemsToShow: 1 },
    { width: 400, itemsToShow: 1 },
    { width: 550, itemsToShow: 2 },
    { width: 768, itemsToShow: 3 },
    { width: 1200, itemsToShow: 4 },
    { width: 1900, itemsToShow: 6 },
];

const extraSmallBreakPoints = [
    { width: 1, itemsToShow: 1 },
    { width: 400, itemsToShow: 1 },
    { width: 550, itemsToShow: 2 },
    { width: 768, itemsToShow: 3 },
    { width: 990, itemsToShow: 4 },
    { width: 1200, itemsToShow: 5 },
    { width: 1900, itemsToShow: 7 },
];

const smallBreakPoints = [
    { width: 1, itemsToShow: 1 },
    { width: 400, itemsToShow: 1 },
    { width: 550, itemsToShow: 2 },
    { width: 768, itemsToShow: 3 },
    { width: 1200, itemsToShow: 5 },
    { width: 1900, itemsToShow: 6 },
];

const mediumBreakPoints = [
    { width: 1, itemsToShow: 1 },
    { width: 400, itemsToShow: 1 },
    { width: 650, itemsToShow: 2 },
    { width: 968, itemsToShow: 3 },
    { width: 1000, itemsToShow: 3 },
    { width: 1200, itemsToShow: 4 },
    { width: 1900, itemsToShow: 5 },
];

const largeBreakPoints = [
    { width: 1, itemsToShow: 1 },
    { width: 400, itemsToShow: 1 },
    { width: 550, itemsToShow: 1 },
    { width: 768, itemsToShow: 2 },
    { width: 1200, itemsToShow: 3 },
    { width: 1900, itemsToShow: 3 },
];

class CardSlider extends Component {
    state = {};
    myArrow({ type, onClick, isEdge }) {
        const pointer =
            type === consts.PREV ? (
                <img
                    src={arrow}
                    alt=''
                    style={{ transform: 'rotate(180deg)' }}
                />
            ) : (
                <img src={arrow} alt='' />
            );

        const en_pointer =
            type === consts.PREV ? (
                <img src={arrow} alt='' />
            ) : (
                <img
                    src={arrow}
                    alt=''
                    style={{ transform: 'rotate(180deg)' }}
                />
            );

        return (
            <>
                {i18next.language === 'ar' ? (
                    <button
                        onClick={onClick}
                        disabled={isEdge}
                        className='sliderBtn'
                    >
                        {pointer}
                    </button>
                ) : (
                    <button
                        onClick={onClick}
                        disabled={isEdge}
                        className='sliderBtn en_sliderBtn'
                    >
                        {en_pointer}
                    </button>
                )}
            </>
        );
    }

    noArrow() {
        return <></>;
    }

    render() {
        const { cards } = this.props;
        return (
            <>
                {this.props.windowWidth > 500 ? (
                    <>
                        {' '}
                        {i18next.language === 'ar' ? (
                            <>
                                {this.props.large ? (
                                    <Carousel
                                        breakPoints={largeBreakPoints}
                                        pagination={false}
                                        isRTL={true}
                                        itemPadding={[40, 15, 40, 15]}
                                        renderArrow={this.myArrow}
                                    >
                                        {cards.slice(0, 10)}
                                    </Carousel>
                                ) : this.props.small ? (
                                    <Carousel
                                        breakPoints={smallBreakPoints}
                                        pagination={false}
                                        isRTL={true}
                                        itemPadding={[40, 15, 40, 15]}
                                        renderArrow={this.myArrow}
                                    >
                                        {cards.slice(0, 10)}
                                    </Carousel>
                                ) : this.props.xsmall ? (
                                    <Carousel
                                        breakPoints={extraSmallBreakPoints}
                                        pagination={false}
                                        isRTL={true}
                                        itemPadding={[40, 15, 40, 15]}
                                        renderArrow={this.myArrow}
                                    >
                                        {cards.slice(0, 10)}
                                    </Carousel>
                                ) : this.props.medium ? (
                                    <Carousel
                                        breakPoints={mediumBreakPoints}
                                        pagination={false}
                                        isRTL={true}
                                        itemPadding={[40, 15, 40, 15]}
                                        renderArrow={this.myArrow}
                                    >
                                        {cards.slice(0, 10)}
                                    </Carousel>
                                ) : this.props.full ? (
                                    <Carousel
                                        breakPoints={breakPoints}
                                        pagination={false}
                                        isRTL={true}
                                        itemPadding={[40, 15, 40, 15]}
                                        renderArrow={this.myArrow}
                                    >
                                        {cards}
                                    </Carousel>
                                ) : (
                                    <Carousel
                                        breakPoints={breakPoints}
                                        pagination={false}
                                        isRTL={true}
                                        itemPadding={[40, 15, 40, 15]}
                                        renderArrow={this.myArrow}
                                    >
                                        {cards.slice(0, 10)}
                                    </Carousel>
                                )}
                            </>
                        ) : (
                            <>
                                {this.props.large ? (
                                    <Carousel
                                        breakPoints={largeBreakPoints}
                                        pagination={false}
                                        // isRTL={true}
                                        itemPadding={[40, 15, 40, 15]}
                                        renderArrow={this.myArrow}
                                    >
                                        {cards.slice(0, 10)}
                                    </Carousel>
                                ) : this.props.small ? (
                                    <Carousel
                                        breakPoints={smallBreakPoints}
                                        pagination={false}
                                        // isRTL={true}
                                        itemPadding={[40, 15, 40, 15]}
                                        renderArrow={this.myArrow}
                                    >
                                        {cards.slice(0, 10)}
                                    </Carousel>
                                ) : this.props.xsmall ? (
                                    <Carousel
                                        breakPoints={extraSmallBreakPoints}
                                        pagination={false}
                                        // isRTL={true}
                                        itemPadding={[40, 15, 40, 15]}
                                        renderArrow={this.myArrow}
                                    >
                                        {cards.slice(0, 10)}
                                    </Carousel>
                                ) : this.props.medium ? (
                                    <Carousel
                                        breakPoints={mediumBreakPoints}
                                        pagination={false}
                                        // isRTL={true}
                                        itemPadding={[40, 15, 40, 15]}
                                        renderArrow={this.myArrow}
                                    >
                                        {cards.slice(0, 10)}
                                    </Carousel>
                                ) : this.props.full ? (
                                    <Carousel
                                        breakPoints={breakPoints}
                                        pagination={false}
                                        // isRTL={true}
                                        itemPadding={[40, 15, 40, 15]}
                                        renderArrow={this.myArrow}
                                    >
                                        {cards}
                                    </Carousel>
                                ) : (
                                    <Carousel
                                        breakPoints={breakPoints}
                                        pagination={false}
                                        // isRTL={true}
                                        itemPadding={[40, 15, 40, 15]}
                                        renderArrow={this.myArrow}
                                    >
                                        {cards.slice(0, 10)}
                                    </Carousel>
                                )}
                            </>
                        )}
                    </>
                ) : (
                    <>
                        {i18next.language === 'ar' ? (
                            <>
                                {this.props.large ? (
                                    <Carousel
                                        breakPoints={largeBreakPoints}
                                        pagination={false}
                                        isRTL={true}
                                        itemPadding={[40, 15, 40, 15]}
                                        renderArrow={this.noArrow}
                                    >
                                        {cards.slice(0, 10)}
                                    </Carousel>
                                ) : this.props.small ? (
                                    <Carousel
                                        breakPoints={smallBreakPoints}
                                        pagination={false}
                                        isRTL={true}
                                        itemPadding={[40, 15, 40, 15]}
                                        renderArrow={this.noArrow}
                                    >
                                        {cards.slice(0, 10)}
                                    </Carousel>
                                ) : this.props.xsmall ? (
                                    <Carousel
                                        breakPoints={extraSmallBreakPoints}
                                        pagination={false}
                                        isRTL={true}
                                        itemPadding={[40, 15, 40, 15]}
                                        renderArrow={this.noArrow}
                                    >
                                        {cards.slice(0, 10)}
                                    </Carousel>
                                ) : this.props.medium ? (
                                    <Carousel
                                        breakPoints={mediumBreakPoints}
                                        pagination={false}
                                        isRTL={true}
                                        itemPadding={[40, 15, 40, 15]}
                                        renderArrow={this.noArrow}
                                    >
                                        {cards.slice(0, 10)}
                                    </Carousel>
                                ) : this.props.full ? (
                                    <Carousel
                                        breakPoints={breakPoints}
                                        pagination={false}
                                        isRTL={true}
                                        itemPadding={[40, 15, 40, 15]}
                                        renderArrow={this.noArrow}
                                    >
                                        {cards}
                                    </Carousel>
                                ) : (
                                    <Carousel
                                        breakPoints={breakPoints}
                                        pagination={false}
                                        isRTL={true}
                                        itemPadding={[40, 15, 40, 15]}
                                        renderArrow={this.noArrow}
                                    >
                                        {cards.slice(0, 10)}
                                    </Carousel>
                                )}
                            </>
                        ) : (
                            <>
                                {this.props.large ? (
                                    <Carousel
                                        breakPoints={largeBreakPoints}
                                        pagination={false}
                                        // isRTL={true}
                                        itemPadding={[40, 15, 40, 15]}
                                        renderArrow={this.noArrow}
                                    >
                                        {cards.slice(0, 10)}
                                    </Carousel>
                                ) : this.props.small ? (
                                    <Carousel
                                        breakPoints={smallBreakPoints}
                                        pagination={false}
                                        // isRTL={true}
                                        itemPadding={[40, 15, 40, 15]}
                                        renderArrow={this.noArrow}
                                    >
                                        {cards.slice(0, 10)}
                                    </Carousel>
                                ) : this.props.xsmall ? (
                                    <Carousel
                                        breakPoints={extraSmallBreakPoints}
                                        pagination={false}
                                        // isRTL={true}
                                        itemPadding={[40, 15, 40, 15]}
                                        renderArrow={this.noArrow}
                                    >
                                        {cards.slice(0, 10)}
                                    </Carousel>
                                ) : this.props.medium ? (
                                    <Carousel
                                        breakPoints={mediumBreakPoints}
                                        pagination={false}
                                        // isRTL={true}
                                        itemPadding={[40, 15, 40, 15]}
                                        renderArrow={this.noArrow}
                                    >
                                        {cards.slice(0, 10)}
                                    </Carousel>
                                ) : this.props.full ? (
                                    <Carousel
                                        breakPoints={breakPoints}
                                        pagination={false}
                                        // isRTL={true}
                                        itemPadding={[40, 15, 40, 15]}
                                        renderArrow={this.noArrow}
                                    >
                                        {cards}
                                    </Carousel>
                                ) : (
                                    <Carousel
                                        breakPoints={breakPoints}
                                        pagination={false}
                                        // isRTL={true}
                                        itemPadding={[40, 15, 40, 15]}
                                        renderArrow={this.noArrow}
                                    >
                                        {cards.slice(0, 10)}
                                    </Carousel>
                                )}
                            </>
                        )}
                    </>
                )}
            </>
        );
    }
}
export default windowSize(CardSlider);
